import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => {
    return (
        <div className="p-6 max-w-4xl mx-auto">
            <Helmet>
                <title>Privacy Policy - PairLingo</title>
                <meta name="description" content="Speak with perfect language partner on PairLingo." />
                <meta name="keywords" content="language learning, pairlingo, chat, match, speaking chat, german language partner chat, language speaking practice" />
            </Helmet>
            <h2 className="text-2xl font-bold mb-4">Privacy Policy</h2>
            <p className="text-gray-700 mb-4">
                At PairLingo, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you use our website and services.
            </p>

            <h3 className="font-semibold text-lg mt-4">1. Information We Collect</h3>
            <p className="text-gray-700 mb-2">
                We collect personal data to provide you with our services. The types of data we may collect include:
            </p>
            <ul className="list-disc ml-6 mb-4 text-gray-700">
                <li>Personal Information: Name, email address, username, language preferences, and bio.</li>
                <li>Login Data: Encrypted passwords and authentication tokens.</li>
                <li>Usage Data: Information about how you use our website, including chat history and user interactions.</li>
                <li>Technical Data: IP address, browser type, device information, and operating system.</li>
            </ul>

            <h3 className="font-semibold text-lg mt-4">2. How We Use Your Information</h3>
            <p className="text-gray-700 mb-2">
                Your data is used to:
            </p>
            <ul className="list-disc ml-6 mb-4 text-gray-700">
                <li>Facilitate language partner matching and communication.</li>
                <li>Provide a personalized user experience.</li>
                <li>Send notifications, updates, and important service-related information.</li>
                <li>Analyze website usage to improve our services.</li>
                <li>Maintain the security and integrity of our platform.</li>
            </ul>

            <h3 className="font-semibold text-lg mt-4">3. Data Security</h3>
            <p className="text-gray-700 mb-4">
                We implement robust security measures to protect your data from unauthorized access, alteration, disclosure, or destruction. Your password is encrypted using secure hashing techniques, and data transmission is secured via HTTPS.
            </p>

            <h3 className="font-semibold text-lg mt-4">4. Cookies and Tracking</h3>
            <p className="text-gray-700 mb-4">
                We use cookies to enhance your experience and collect information about website usage. You can disable cookies in your browser settings, but some features may not function correctly.
            </p>

            <h3 className="font-semibold text-lg mt-4">5. Sharing Your Information</h3>
            <p className="text-gray-700 mb-4">
                We do not sell, trade, or share your personal information with third parties except when required by law or to provide our services (e.g., email verification through third-party providers).
            </p>

            <h3 className="font-semibold text-lg mt-4">6. Your Rights</h3>
            <p className="text-gray-700 mb-2">
                As a user, you have the following rights regarding your data:
            </p>
            <ul className="list-disc ml-6 mb-4 text-gray-700">
                <li><strong>Right to Access:</strong> You can request access to your personal data.</li>
                <li><strong>Right to Rectification:</strong> You can request correction of incorrect or incomplete information.</li>
                <li><strong>Right to Deletion:</strong> You can request the deletion of your data under certain conditions.</li>
                <li><strong>Right to Data Portability:</strong> You can receive your personal data in a structured format.</li>
                <li><strong>Right to Object:</strong> You can object to the processing of your data under specific circumstances.</li>
            </ul>

            <h3 className="font-semibold text-lg mt-4">7. Data Retention</h3>
            <p className="text-gray-700 mb-4">
                We retain your data as long as necessary to provide our services or as required by applicable laws. You can request the deletion of your data at any time.
            </p>

            <h3 className="font-semibold text-lg mt-4">8. Third-Party Links</h3>
            <p className="text-gray-700 mb-4">
                Our website may contain links to third-party websites. We are not responsible for the content or privacy practices of these sites. Please review their privacy policies before interacting with them.
            </p>

            <h3 className="font-semibold text-lg mt-4">9. Changes to This Policy</h3>
            <p className="text-gray-700 mb-4">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
            </p>

            <h3 className="font-semibold text-lg mt-4">10. Contact Us</h3>
            <p className="text-gray-700 mb-4">
                If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at: <a href="mailto:support@pairlingo.com" className="text-indigo-600">support@pairlingo.com</a>
            </p>

            <p className="text-gray-700 mt-6">
                By using PairLingo, you agree to the collection and use of information as outlined in this Privacy Policy.
            </p>
        </div>
    );
};

export default PrivacyPolicy;  